<template>
  <HrPageLayout title="Interview Management" subtitle="Schedule and manage interviews" :breadcrumb-items="[{ label: 'Recruitment' }, { label: 'Interviews' }]">
    <template #header-actions>
      <div class="hr-flex hr-flex-center hr-gap-2">
        <button class="hr-btn" @click="refresh">Refresh</button>
      </div>
    </template>

    <div class="hr-chart-card hr-mt-3">
      <div class="hr-chart-header">
        <h5 class="hr-chart-title"><i class="bx bx-calendar"></i> Scheduled Interviews</h5>
      </div>
      <div class="hr-chart-body">
        <div v-if="loading" class="hr-loading-state">
          <div class="hr-spinner"></div>
          <p>Loading interviews...</p>
        </div>
        <div v-else-if="interviews.length === 0" class="hr-empty-state">
          <i class="bx bx-file"></i>
          <h5>No interviews scheduled</h5>
          <p>Schedule interviews from shortlisted candidates.</p>
        </div>
        <div v-else class="hr-table-wrapper">
          <table class="hr-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Candidate</th>
                <th>Vacancy</th>
                <th>Interview Date</th>
                <th style="text-align:center">Status</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(iv, i) in interviews" :key="iv.id">
                <td>{{ i + 1 }}</td>
                <td>{{ iv.candidateName }}</td>
                <td>{{ iv.vacancyTitle }}</td>
                <td>{{ iv.dateTime }}</td>
                <td style="text-align:center"><span class="hr-badge hr-badge-warning">{{ iv.status }}</span></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </HrPageLayout>
</template>

<script>
/* eslint-disable */
import HrPageLayout from "@/components/hrActions/HrPageLayout.vue";
import { authUrl, execute } from "@/api";

export default {
  name: 'InterviewManagement',
  components: { HrPageLayout },
  data() { return { loading: false, interviews: [] }; },
  mounted() { this.fetchInterviews(); },
  methods: {
    async fetchInterviews() {
      this.loading = true;
      const data = new FormData();
      data.append('function', 'getInterviews');
      try {
        const res = await execute(data, authUrl);
        if (res.data.success) this.interviews = res.data.data.interviews || [];
      } catch (e) { console.error(e); }
      this.loading = false;
    },
    refresh() { this.fetchInterviews(); }
  }
}
</script>
